import React from 'react'

export type CollapsibleContextProps = {
  onExpand: () => void
  onCollapse: () => void
  onToggleExpand?: () => void
  isExpanded?: boolean
  defaultIsExpanded?: boolean
}

export const CollapsibleContext = React.createContext<CollapsibleContextProps>({
  onExpand: () => {},
  onCollapse: () => {},
  onToggleExpand: () => {},
  isExpanded: false,
  defaultIsExpanded: false,
})

export const useCollapsibleContext = () => React.useContext(CollapsibleContext)
